// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ComboPrices_RemoverInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /so/combo_prices/remover — soft-delete com semantica:
 * `active = 0` = a franquia DESLIGOU o combo (deixa de vende-lo ali).
 */
import { registerContract } from './validate'

export interface ComboPrices_RemoverInput {
so_combo_price_id: number
}

registerContract('ComboPrices_RemoverInput', {
  so_combo_price_id: { type: 'number',  required: true },
})
